import { render, staticRenderFns } from "./EditActivityQuiz.vue?vue&type=template&id=6701fc2b"
import script from "./EditActivityQuiz.vue?vue&type=script&lang=js"
export * from "./EditActivityQuiz.vue?vue&type=script&lang=js"
import style0 from "./EditActivityQuiz.vue?vue&type=style&index=0&id=6701fc2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports